export function getEmitterDefaultOption() {
    return {
        selectorAttribute: `data-redirect-to`,
    }
}

export function initializeEmitter(options = getEmitterDefaultOption()) {
    console.log("Scroll navigator initializing...");
    document.querySelectorAll('a[data-redirect-to]').forEach(a => {
        a.addEventListener('click', clickevt => {
            clickevt.preventDefault();
            clickevt.stopPropagation();
            clickevt.stopImmediatePropagation();

            const targetUrl = String(a.href);
            const moveToSelector = a.getAttribute(options.selectorAttribute).split(';');
            const scrollTo = moveToSelector[0];
            const clickTo = moveToSelector[1];
            const currentUrl = String(window.location.href);

            // Verifica se siamo GIÀ sulla pagina target (stessa pagina)
            if (currentUrl.indexOf(targetUrl) !== -1 || currentUrl === targetUrl) {
                console.log("Già sulla stessa pagina - scroll/click diretto.");
                document.dispatchEvent(new CustomEvent('scrollto', {
                    detail: {
                        scrollTo: scrollTo,
                        clickTo: clickTo,
                    }
                }));
            }
            else {
                console.log("Reindirizzamento ad un'altra pagina.");
                sessionStorage.setItem('scrollIntoViewEnabled', 'true');
                sessionStorage.setItem('scrollTo', scrollTo);
                sessionStorage.setItem('clickTo', clickTo);
                window.location.href = targetUrl; // FIX: era "href"
            }
        });
    });
    console.log("Scroll navigator initialized.");
}

export function getReceiverDefaultOptions() {
    return {
        receiverDataAttribute: `data-redirect-rcv`,
        delay: {
            scroll: 500,
            move: 1000,
            click: 1200,
        },
        horizontalScrollAfterClick: true,
    }
}

export function initializeReceiver(options = getReceiverDefaultOptions()) {
    /**
     * @param {string} where
     * @param {string} clickTo
     */
    function scrollAndClick(where, clickTo) {
        setTimeout(() => {
            const scrollTo = document.querySelector(where);
            if (scrollTo) {
                scrollTo.scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                });
            }
            else {
                console.error("Unable to find control where to scroll.");
            }
        }, options.delay.scroll);

        const mClickTo = document.querySelector(clickTo);
        if (mClickTo) {
            if (options.horizontalScrollAfterClick) {
                setTimeout(() => {
                    mClickTo.scrollIntoView({
                        behavior: 'smooth',
                        inline: 'center',
                        block: 'nearest'
                    })
                }, options.delay.move)
            }
            setTimeout(() => {
                mClickTo.click();
            }, options.delay.click);
                
        }
    }

    if (document.querySelector(`[${options.receiverDataAttribute}]`)) {
        // Caso 1: viene lanciato l'evento nella stessa pagina - si gestisce l'evento
        document.addEventListener('scrollto', scrollevt => {
            scrollAndClick(scrollevt.detail.scrollTo, scrollevt.detail.clickTo);
        });

        // Caso 2: viene fatto un redirect - leggo i sessionStorage
        document.addEventListener('DOMContentLoaded', () => {
            if (sessionStorage.getItem('scrollIntoViewEnabled')) {
                const scrollToSelector = sessionStorage.getItem('scrollTo');
                const clickToSelector = sessionStorage.getItem('clickTo');
                scrollAndClick(scrollToSelector, clickToSelector);
            }
            sessionStorage.removeItem('scrollIntoViewEnabled');
            sessionStorage.removeItem('scrollTo');
            sessionStorage.removeItem('clickTo');
        });
    }
}